// extracted by mini-css-extract-plugin
module.exports = {"timestamp-rows":"PriceTimestamps_timestamp-rows__3RPVO","timestamp-label":"PriceTimestamps_timestamp-label__3VyVx","timestamp-value":"PriceTimestamps_timestamp-value__2RrzI"};